/**
 * Created by scuzzort3 on 8/11/17.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .directive('communitiesDropDown', communitiesDropDown);

    communitiesDropDown.$inject = [];

    function communitiesDropDown() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/communitiesDropDown/communitiesDropDown.view.html',
            controller: 'CommunitiesDropDownController',
            controllerAs: 'vm',
            scope: {
                onCommunityClick: '&',
                refreshFlag: '=',
                searchText: '=',
                disabledCommunityId: '=',
                startCollapsed: '=',
                showLeafs: '@',
                showInactive: '@'
            }
        };
    }
})();